module.exports = __webpack_public_path__ + "static/ logo_final-50bf1ee93a4288bef147b3e4b3f70e81.png";